function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChamberlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 468 114",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.783,57.188l-0.116,-1.796c-0.018,-0.382 -0.031,-0.768 -0.031,-1.152c0,-3.04 0.514,-6.007 1.495,-8.878c-0.09,0.927 -0.164,1.849 -0.164,2.777c0,0.322 0.011,0.654 0.026,0.982c0.341,8.439 4.521,16.534 11.465,22.206c11.917,9.723 28.578,9.356 38.3,-0.679c0.198,1.166 1.536,9.288 1.599,9.659c-1.818,1.659 -3.787,3.026 -5.845,4.056c-10.757,5.381 -24.254,3.501 -34.377,-4.778c-6.992,-5.71 -11.492,-13.879 -12.352,-22.397Z",
    style: {
      fill: "#00aeef",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.408,15.876c-5.613,-2.441 -12.138,-3.715 -19.722,-3.167c-20.896,1.613 -39.427,20.202 -38.608,41.415c0.505,13.052 5.135,27.83 23.561,38.243c4.766,2.704 5.358,3.777 0.04,1.69c-18.717,-7.317 -28.017,-24.33 -28.683,-42.345c-1.084,-27.741 22.294,-52.856 52.578,-50.214c6.322,0.53 11.218,1.512 15.925,3.346l-5.091,11.032Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.559,25.25l0,0.004c-12.706,-4.588 -27.814,-0.58 -34.188,9.858c-2.556,4.198 -3.66,8.912 -3.461,13.64c0.288,7.142 3.605,14.268 9.295,19.724c-2.934,-4.165 -4.658,-8.861 -4.852,-13.581c-0.171,-4.342 0.849,-8.656 3.19,-12.484c5.425,-8.912 16.306,-12.628 27.037,-9.85l2.979,-7.311Z",
    style: {
      fill: "#00aeef",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.545,65.255c-2.024,22.842 -18.32,39.267 -38.762,42.95c-26.836,4.838 -55.808,-12.558 -63.145,-39.819c-0.171,-0.528 -0.083,-0.605 -0.301,-1.618c-0.529,-2.973 -1.612,-2.781 -1.272,0.426c0.253,2.341 0.535,3.364 1.033,5.038c8.539,27.965 36.182,44.265 66.533,38.795c24.179,-4.353 44.404,-27.592 45.654,-51.602l-9.74,5.83Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.133,41.391c-0.474,1.232 -1.392,3.442 -3.279,5.689c-2.677,3.106 -6.91,5.829 -13.056,5.829c-10.019,0 -17.679,-7.334 -17.679,-19.973c0,-12.855 8.303,-19.769 17.934,-19.769c11.808,0 14.577,9.036 15.429,11.677l-7.064,1.867c-0.103,-0.695 -0.448,-2.302 -1.392,-3.734c-0.806,-1.188 -2.897,-3.327 -6.797,-3.327c-6.164,0 -10.45,5.086 -10.45,13.17c0,8.624 4.55,13.396 10.498,13.396c3.535,0 5.667,-1.723 7.228,-3.706c1.226,-1.651 1.724,-3.048 1.981,-3.9l6.647,2.781Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.746,14.126l0,13.768c2.019,-2.036 4.816,-3.533 8.504,-3.533c3.326,0 5.891,1.287 7.336,2.893c2.195,2.346 2.263,5.082 2.263,8.147l0,16.541l-6.315,0l0,-14.731c-0.131,-2.405 -0.131,-2.988 -0.437,-3.805c-0.218,-0.537 -1.127,-2.938 -4.667,-2.938c-4.13,0 -6.054,3.319 -6.489,4.878c-0.195,0.856 -0.195,1.287 -0.195,4.274l0,12.322l-6.452,0l0,-37.816l6.452,0Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.401,38.61c-1.293,0.638 -2.745,1.121 -5.629,1.608c-2.303,0.327 -5.36,0.853 -5.36,3.688c0,2.09 1.77,3.174 4.338,3.174c3.271,0 5.569,-1.505 6.271,-3.107c0.38,-0.802 0.38,-1.614 0.38,-2.413l0,-2.95Zm-16.561,-5.572c0.105,-1.345 0.217,-2.463 1.078,-4.02c2.561,-4.657 8.941,-4.657 10.658,-4.657c2.568,0 5.681,0.323 8.035,1.711c3.162,1.939 3.22,4.444 3.22,7.334l0,14.211c0,2.022 0,2.725 1.16,4.325l-7.59,0c-0.063,-0.634 -0.162,-1.706 -0.162,-2.076c-1.392,1.177 -4.234,2.723 -7.934,2.723c-6.046,0 -9.69,-3.743 -9.69,-8.35c0,-1.336 0.316,-2.577 0.861,-3.651c1.918,-3.843 6.037,-4.715 8.619,-5.187c5.515,-1.134 5.946,-1.239 8.306,-1.995c0,-1.324 -0.111,-4.068 -4.562,-4.068c-2.688,0 -4.13,0.869 -4.775,1.715c-0.683,0.858 -0.631,1.607 -0.631,2.353l-6.593,-0.368Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.682,25.164l6.369,0l0,2.995c2.152,-2.672 5.952,-3.798 8.47,-3.798c2.506,0 5.673,0.969 7.444,4.117c1.068,-1.496 3.846,-4.117 8.561,-4.117c2.692,0 5.251,0.748 7.066,2.731c2.155,2.355 2.108,5.207 2.108,7.991l0,16.859l-6.373,0l0,-14.78c0,-2.506 0.363,-6.745 -4.501,-6.745c-2.049,0 -3.704,1.134 -4.562,2.519c-1.231,1.98 -1.395,4.119 -1.395,6.411l0,12.595l-6.363,0l0,-14.934c0,-1.925 0,-2.634 -0.22,-3.435c-0.489,-1.759 -1.878,-3.156 -4.117,-3.156c-1.938,0 -3.823,1.134 -4.94,3.111c-1.125,2.088 -1.178,4.613 -1.178,7.217l0,11.197l-6.369,0l0,-26.778Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.141,30.207c-2.898,0 -6.308,2.195 -6.308,7.934c0,1.646 0.198,2.779 0.417,3.419c1.287,5.089 5.622,5.089 6.147,5.089c4.728,0 6.273,-4.776 6.391,-8.309c0.164,-5.302 -3.155,-8.133 -6.647,-8.133Zm-6.207,-16.081l0,13.289c2.14,-1.989 4.826,-3.054 7.752,-3.054c6.054,0 11.751,5.575 11.751,14.09c0,8.737 -5.801,14.307 -12.168,14.307c-3.535,0 -5.946,-1.986 -7.335,-3.597l0,2.781l-6.388,0l0,-37.816l6.388,0Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.732,35.117c-0.603,-4.169 -3.166,-5.613 -6.009,-5.613c-3.431,0 -5.783,1.99 -6.54,5.613l12.549,0Zm7.281,10.823c-3.333,4.462 -7.607,6.818 -13.073,6.818c-7.017,0 -13.775,-4.452 -13.775,-14.307c0,-9.004 5.806,-14.09 13.351,-14.09c7.079,0 10.007,4.229 10.553,5.032c2.194,3.107 2.672,7.769 2.734,10.443l-19.815,0c0.742,4.237 3.376,6.654 7.603,6.654c4.39,0 6.146,-2.584 6.961,-3.71l5.461,3.16Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.104,25.164l0,3.81c0.799,-1.403 2.576,-4.565 8.565,-4.399l0,6.592c-1.388,0.047 -3.789,0.1 -5.781,1.614c-2.736,2.071 -2.784,4.807 -2.784,9.247l0,9.914l-6.208,0l0,-26.778l6.208,0Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.908,
    y: 14.126,
    width: 6.479,
    height: 37.816,
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.993,38.61c-1.291,0.638 -2.731,1.121 -5.624,1.608c-2.295,0.327 -5.347,0.853 -5.347,3.688c0,2.09 1.761,3.174 4.336,3.174c3.27,0 5.569,-1.505 6.266,-3.107c0.369,-0.802 0.369,-1.614 0.369,-2.413l0,-2.95Zm-16.543,-5.572c0.092,-1.345 0.203,-2.463 1.062,-4.02c2.579,-4.657 8.943,-4.657 10.657,-4.657c2.585,0 5.69,0.323 8.043,1.711c3.147,1.939 3.223,4.444 3.223,7.334l0,14.211c0,2.022 0,2.725 1.176,4.325l-7.618,0c-0.061,-0.634 -0.159,-1.706 -0.159,-2.076c-1.392,1.177 -4.23,2.723 -7.926,2.723c-6.046,0 -9.699,-3.743 -9.699,-8.35c0,-1.336 0.317,-2.577 0.857,-3.651c1.924,-3.843 6.05,-4.715 8.637,-5.187c5.504,-1.134 5.933,-1.239 8.29,-1.995c0,-1.324 -0.104,-4.068 -4.54,-4.068c-2.694,0 -4.143,0.869 -4.774,1.715c-0.697,0.858 -0.643,1.607 -0.643,2.353l-6.586,-0.368Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.698,51.942l-6.365,0l0,-26.777l6.365,0l0,26.777Zm0,-30.956l-6.365,0l0,-6.485l6.365,0l0,6.485Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.618,25.164l6.49,0l0,3.158c0.31,-0.474 0.961,-1.34 2.088,-2.091c1.598,-1.159 4.063,-1.87 6.158,-1.87c3.054,0 5.671,1.398 7.011,3.21c1.657,2.263 1.657,5.142 1.657,8.631l0,15.74l-6.365,0l0,-13.658c0,-1.985 0,-3.321 -0.227,-4.061c-0.572,-2.362 -2.292,-3.597 -4.392,-3.597c-2.089,0 -4.006,1.235 -4.921,3.007c-1.009,1.983 -1.009,4.707 -1.009,6.695l0,11.614l-6.49,0l0,-26.778Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.202,101.053c-4.713,0 -9.181,-2.616 -9.181,-7.792c0,-4.946 4.158,-7.885 8.825,-7.885c2.865,0 5.386,0.996 7.639,2.769l-1.337,2.102c-2.035,-1.431 -3.725,-2.317 -6.282,-2.317c-3.184,0 -6.348,1.827 -6.348,5.331c0,3.672 3.385,5.259 6.636,5.259c2.413,0 4.407,-0.699 6.396,-2.074l1.112,2.32c-2.299,1.585 -4.628,2.287 -7.46,2.287Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.844,87.949c-3.216,0 -6.544,1.703 -6.544,5.312c0,3.555 3.193,5.243 6.378,5.243c3.182,0 6.626,-1.724 6.626,-5.321c0,-3.619 -3.243,-5.234 -6.46,-5.234Zm-0.198,13.104c-4.58,0 -8.876,-2.84 -8.876,-7.771l0,-0.389c0,-4.963 4.608,-7.517 9.099,-7.517c4.652,0 8.97,2.769 8.97,7.772c0,5.065 -4.524,7.905 -9.193,7.905Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.135,100.549l0,-10.367l-5.578,8.285l-5.594,-8.285l0,10.367l-2.53,0l0,-14.741l2.53,0l5.594,8.486l5.604,-8.486l2.479,0l0,14.741l-2.505,0Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.401,100.549l0,-10.367l-5.573,8.285l-5.606,-8.285l0,10.367l-2.504,0l0,-14.741l2.504,0l5.606,8.486l5.608,-8.486l2.468,0l0,14.741l-2.503,0Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.136,100.549l0,-14.741l12.975,0l0,2.507l-10.467,0l0,3.386l5.754,0l0,2.506l-5.754,0l0,3.843l10.753,0l0,2.499l-13.261,0Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.054,88.315l-6.688,0l0,3.697l6.836,0c1.402,0 2.837,-0.282 2.837,-1.961c0,-1.254 -0.584,-1.736 -2.985,-1.736Zm2.738,12.234l-4.276,-6.042l-5.15,0l0,6.042l-2.528,0l0,-14.741l9.113,0c2.986,0 5.59,0.937 5.59,4.357c0,2.502 -1.518,3.983 -3.937,4.295l4.287,6.089l-3.099,0Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.682,101.053c-4.724,0 -9.189,-2.616 -9.189,-7.792c0,-4.946 4.155,-7.885 8.813,-7.885c2.876,0 5.406,0.996 7.652,2.769l-1.337,2.102c-2.048,-1.431 -3.725,-2.317 -6.284,-2.317c-3.199,0 -6.354,1.827 -6.354,5.331c0,3.672 3.397,5.259 6.637,5.259c2.422,0 4.402,-0.699 6.413,-2.074l1.091,2.32c-2.288,1.585 -4.635,2.287 -7.442,2.287Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.714,
    y: 85.782,
    width: 2.502,
    height: 14.767,
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.691,88.623l-3.214,6.006l6.422,0l-3.208,-6.006Zm6.336,11.926l-1.87,-3.443l-8.982,0l-1.82,3.443l-2.854,0l7.962,-14.741l2.504,0l8.028,14.741l-2.968,0Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.298,100.549l0,-14.741l2.513,0l0,12.242l8.982,0l0,2.499l-11.495,0Z",
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.556,
    y: 68.338,
    width: 333.905,
    height: 0.559,
    style: {
      fill: "#071336",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChamberlain);
export default __webpack_public_path__ + "static/media/Chamberlain.57f6bdbed35908be0d6ce1408ec61c43.svg";
export { ForwardRef as ReactComponent };